import * as _ from 'underscore';

export const paramTypes = [
    { id: 0, title: '-' },
    { id: 3, title: 'Reps' },
    { id: 24, title: 'Rep Range (min-max)' },
    { id: 1, title: 'Weight (lb)' },
    { id: 19, title: 'Weight (kg)' },
    { id: 2, title: 'Weight (%)' },
    { id: 9, title: 'Weight (LWP+)' },
    { id: 4, title: 'Time (min::sec)' },
    { id: 18, title: 'Seconds (s)' },
    { id: 10, title: 'Distance (miles)' },
    { id: 5, title: 'Distance (yd)' },
    { id: 11, title: 'Distance (ft)' },
    { id: 12, title: 'Distance (inches)' },
    { id: 6, title: 'Distance (meters)' },
    { id: 7, title: 'Height (inches)' },
    { id: 8, title: 'Calories (cal)' },
    { id: 14, title: 'RPE' },
    { id: 15, title: 'Watts' },
    { id: 17, title: 'Velocity (m/s)' },
    { id: 13, title: 'Other Number' }
];

export const redzoneTypes = [
    { id: 0, title: 'For Completion' },
    { id: 8, title: 'Calories' },
    { id: 7, title: 'Feet' },
    { id: 12, title: 'Inches' },
    { id: 6, title: 'Meters' },
    { id: 10, title: 'Miles' },
    { id: 2, title: 'Reps' },
    { id: 3, title: 'Rounds' },
    { id: 18, title: 'Seconds' },
    { id: 4, title: 'Time' },
    { id: 17, title: 'Velocity (m/s)' },
    { id: 14, title: 'RPE' },
    { id: 15, title: 'Watts' },
    { id: 1, title: 'Weight' },
    { id: 5, title: 'Yards' },
    { id: 19, title: 'Data' },
    { id: 16, title: 'Percent' },
    { id: 13, title: 'Other Number' }
];

export const weightParamTypes = [1, 2, 9, 19];
export const repParamTypes = [3, 24];

export const getParamType = function(id) {
    return _.find(paramTypes, item => item.id === id);
};

export const blockCategories = [
    { id: 0, title: 'Uncategorized' },
    { id: 1, title: 'Prep' },
    { id: 2, title: 'Speed/Agility' },
    { id: 3, title: 'Skill/Tech' },
    { id: 4, title: 'Strength/Power' },
    { id: 5, title: 'Conditioning' },
    { id: 6, title: 'Recovery' }
];

export const redzones = {
    COMPLETION: 0,
    CALORIES: 8,
    FEET: 7,
    INCHES: 12,
    METERS: 6,
    MILES: 10,
    REPS: 2,
    ROUNDS: 3,
    SECONDS: 18,
    TIME: 4,
    VELOCITY: 17,
    PERCENT: 16,
    WATTS: 15,
    WEIGHT: 1,
    YARDS: 5,
    OTHER: 13
};

export const workoutParamTypes = {
    NONE: 0,
    WEIGHT: 1,
    WEIGHT_PERCENT: 2,
    REPS: 3,
    TIME: 4,
    DISTANCE_YARDS: 5,
    DISTANCE_METERS: 6,
    HEIGHT_INCHES: 7,
    CALORIES: 8,
    LINEAR: 9,
    DISTANCE_MILES: 10,
    DISTANCE_FEET: 11,
    DISTANCE_INCHES: 12,
    OTHER_NUMBER: 13,
    RPE: 14,
    WATTS: 15,
    VELOCITY: 17,
    SECONDS: 18,
    WEIGHT_KG: 19,
    REP_RANGE: 24
};
